import { useTranslation } from 'react-i18next';

import { useMrpActivities } from './useMrpActivities';

export type ActivityFilterLabel = {
  entityId: string;
  /** "Activiteit: Wondzorg" — the activity's name, marked as the activity filter. */
  label: string;
};

/**
 * The picked activities as the filters name them, in the order they were picked. An id the list does not
 * hold (yet) is left out. One wording for the chips and the toolbar's summary.
 */
export const useActivityFilterLabels = (
  activityIds: string[]
): ActivityFilterLabel[] => {
  const { t } = useTranslation('common');
  const activities = useMrpActivities();

  return activityIds.flatMap((activityId) =>
    activities
      .filter(({ entityId }) => entityId === activityId)
      .map(({ entityId, name }) => ({
        entityId,
        label: `${t('appointmentsOverview.filters.activity')}: ${name}`
      }))
  );
};
